export const VERSION = '4.0.1';
//# sourceMappingURL=version.mjs.map
